/**
 * Re-authenticated reveal of stored API tokens (POST /users/credentials/reveal).
 */

export async function revealStoredCredential(apiBase, authHeaders, { password, scope, mappingId }) {
  const response = await fetch(`${apiBase}/users/credentials/reveal`, {
    method: 'POST',
    headers: {
      Authorization: authHeaders.Authorization || '',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      password,
      scope,
      ...(mappingId ? { mappingId } : {}),
    }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const msg = data.error || `Reveal failed (${response.status})`;
    throw new Error(msg);
  }
  return data;
}
